import { IconPointFilled } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusTone } from '../../StatusBadge.js';
import type { RequisitionPriority, RequisitionStatus } from './types.js';

/**
 * Tasarımdaki renkler: Approved yeşil, Pending Approval sarı, In Progress ve PO Issued mavi,
 * Closed gri (`satin-alma-akisi.jpeg` "Material Requisition").
 */
export const REQUISITION_TONE: Record<RequisitionStatus, StatusTone> = {
  draft: 'neutral',
  pending_approval: 'warning',
  office_approval: 'warning',
  approved: 'success',
  returned: 'danger',
  cancelled: 'neutral',
  in_progress: 'info',
  po_issued: 'info',
  closed: 'neutral',
};

export function RequisitionStatusBadge({ status }: { status: RequisitionStatus }) {
  const { t } = useTranslation();
  return (
    <StatusBadge tone={REQUISITION_TONE[status]} icon={<IconPointFilled size={10} />}>
      {t(`purchasing.statuses.${status}`)}
    </StatusBadge>
  );
}

/** Satır önceliği: High kırmızı, Normal sarı (tasarım), Urgent kırmızı. */
const PRIORITY_TONE: Record<RequisitionPriority, StatusTone> = {
  Normal: 'warning',
  High: 'danger',
  Urgent: 'danger',
};

export function PriorityBadge({ priority }: { priority: RequisitionPriority }) {
  const { t } = useTranslation();
  return (
    <StatusBadge tone={PRIORITY_TONE[priority]}>
      {t(`purchasing.priorities.${priority}`)}
    </StatusBadge>
  );
}
